import {
  useState,
  useEffect
} from "react";
import {
  io,
  Socket
} from "socket.io-client";

import { useAuthContext } from "../useAuthContext";

export function useSocket(topicId: string): [Socket | null] {
  const { authDataState } = useAuthContext();
  const [ socket, setSocket ] = useState<Socket | null>(null);

  useEffect(() => {
    if (!authDataState) {
      return;
    }

    if (authDataState.authenticated && !socket) {
      setSocket(io(`${process.env.REACT_APP_API_BASE_URL}`, {
        autoConnect: true,
        extraHeaders: {
          topicId,
          Authorization: `Bearer ${authDataState.idToken}`
        }
      }));
    }
  }, [
    authDataState,
    socket,
    topicId
  ]);

  return [ socket ];
}